import React, { useContext } from 'react';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';
import Button from '@mui/material/Button';
import { withStyles } from '@mui/styles';
import { observer } from 'mobx-react-lite';
import GeneralEvents from 'events/GeneralEvents';
import AssessmentBuilderEvents from 'events/AssessmentBuilderEvents';
import Popover from '@mui/material/Popover';
import { checkHasCompanyFeature } from 'helper/commonFunctions';
import { AI_AUDITION_GENERATION, REQUEST_CUSTOM_ASSESSMENT } from 'helper/constants';
import { appCtx } from '../../../appStore';
import styles from '../styles';


const CreateNewAssessmentDropdown = observer(({
    light, buttonLabel = 'Create New Assessment', className = '', classes, fullLimit, allRequestsIsUsed
}) => {
    const { openTTBuilderDialog, openTTRequestDialog, openTTAiGeneratorDialog, company } = useContext(appCtx);
    const { button, popoverRoot, popoverPaper, popoverItem, disabledPopoverItem } = classes;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const companyHasAiGeneration = checkHasCompanyFeature(company, AI_AUDITION_GENERATION);
    const companyCanCreateCustomRequests = checkHasCompanyFeature(company, REQUEST_CUSTOM_ASSESSMENT);

    const openAssessmentBuilderModal = () => {
        localStorage.removeItem('assessmentName');
        setAnchorEl(null);
        openTTBuilderDialog();
        GeneralEvents.TB_INTENT({ context: 'create new assessment' });
    };

    const openAssessmentRequestModal = () => {
        setAnchorEl(null);
        openTTRequestDialog();
    };

    const openAssessmentGeneratingModal = () => {
        GeneralEvents.TB_INTENT({ context: 'generate new assessment' });
        AssessmentBuilderEvents.GENERATE_CLICKED();
        openTTAiGeneratorDialog();
    };

    const renderMenuItems = () => {
        const OPTIONS = [
            {
                value: 'standard',
                label: 'New Standard Assessment',
                onClick: openAssessmentBuilderModal,
                disabledItem: fullLimit
            }
        ];

        if (company) {
            if (companyCanCreateCustomRequests) {
                OPTIONS.push({
                    value: 'custom',
                    label: 'Request Custom Assessment',
                    onClick: openAssessmentRequestModal,
                    disabledItem: allRequestsIsUsed
                });
            }
            if (companyHasAiGeneration) {
                OPTIONS.push({
                    value: 'ai',
                    label: 'Generate Assessment',
                    onClick: openAssessmentGeneratingModal,
                    disabledItem: false
                });
            }
        }

        return OPTIONS.map(({ value, label = value, onClick, disabledItem }, index) => (
            <div className={clsx(popoverItem, disabledItem && disabledPopoverItem)} onClick={disabledItem ? null : onClick} role="button" tabIndex={index}>
                {label}
            </div>
        ));
    };

    return (
        <>
            <Button
                aria-controls="customized-menu"
                aria-haspopup="true"
                variant={!light ? 'contained' : 'text'}
                color="primary"
                onClick={e => setAnchorEl(e.currentTarget)}
                className={clsx(button, className)}
            >
                <span>{buttonLabel}</span>
            </Button>
            <Popover
                anchorEl={anchorEl}
                keepMounted
                open={open}
                classes={{ root: popoverRoot, paper: popoverPaper }}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                {renderMenuItems()}
            </Popover>
        </>
    );
});

export default withRouter(withStyles(styles)(CreateNewAssessmentDropdown));
